import { ArenaGameState, BidRecord } from '../../state/ArenaTypes';
import { GameTableConfig } from '../../engine/tableConfig/types';
import { ContractFormatContext } from '../common/IGameRules';
import { IScorePresenter } from '../common/IScorePresenter';
import { IContractFormatterStrategy } from '../common/IContractFormatterStrategy';

/**
 * Presentation-only contract formatter for Hearts (Points Avoidance / No Auction).
 */
export class HeartsContractFormatter implements IContractFormatterStrategy {
  public formatContractName(
    _rawBid?: number | null,
    _direction?: string | null,
    _suit?: string | null,
    _isNoTrump?: boolean,
    fallbackContract?: string,
    _config?: GameTableConfig
  ): string {
    return fallbackContract || 'Points Avoidance';
  }

  public formatContractOutcome(
    gameState: ArenaGameState,
    _context?: ContractFormatContext,
    _config?: GameTableConfig,
    _scorePresenter?: IScorePresenter
  ): string {
    const history = Array.isArray(gameState.scoreHistory) ? gameState.scoreHistory : [];
    const latest = history.find(h => h && h.handNumber === gameState.handNumber) || (history.length > 0 ? history[history.length - 1] : null);
    if (latest?.summary) {
      return latest.summary;
    }
    if (gameState.lastActionMessage) {
      return gameState.lastActionMessage;
    }
    const pTaken = gameState.seatPoints ?? (gameState as any).pointsTaken ?? (gameState.gameExt as any)?.seatPoints;
    if (Array.isArray(pTaken) && pTaken.length >= 4) {
      const fmt = (pts: number) => (pts > 0 ? `+${pts}` : `${pts || 0}`);
      return `Pts taken: P1 (${fmt(pTaken[0])}), P2 (${fmt(pTaken[1])}), P3 (${fmt(pTaken[2])}), P4 (${fmt(pTaken[3])})`;
    }
    return 'Round Complete';
  }

  public getContractSummaryText(gameState: ArenaGameState, _config?: GameTableConfig): string | null {
    const raw = (gameState as any).contractSummary;
    return raw ? String(raw) : null;
  }

  public getHighestBidRecord(_bids?: BidRecord[]): BidRecord | null {
    return null;
  }
}
